<div class="content-width container">
  <div class="game ion-no-margin ion-no-padding">
    <div class="game-stretch" id="gameCanvas"></div>
  </div>
</div>
